import React from 'react'
import { Users } from 'lucide-react'
import GenericTable from '../../components/GenericTable'

const AdminUsers = () => {
  return (
    <GenericTable
      tableName="users"
      title="Users"
      icon={Users}
      iconColor="slate"
      searchFields={['username', 'email', 'role', 'user_number']}
      hiddenFields={['user_id', 'created_at', 'updated_at']}
      primaryKey="user_id"
      defaultFields={['username', 'email', 'role', 'is_active', 'first_name', 'last_name', 'permissions', 'last_login']}
      addFields={['username', 'email', 'password_hash', 'role', 'first_name', 'last_name', 'is_active', 'permissions']}
      editFields={[
        'username', 'email', 'password_hash', 'role', 'first_name', 'last_name', 'is_active',
        'permissions', 'user_status'
        // Excluded: user_id, last_login, created_at, updated_at
      ]}
    />
  )
}

export default AdminUsers